import styled, { css } from 'styled-components';

import { grid } from '@components/Styled/mixins';

const PropertyCardWrapper = styled.article`
  ${grid()};

  ${({ theme }) => css`
    // Two pixels are added because some browsers do not render edge curves correctly
    border-radius: calc(${theme.spacing(2)} + 2px);
    grid-template-rows: ${theme.spacing(36)} auto;
    box-shadow: ${theme.shadows.sm[1]};
    height: fit-content;
    background-color: ${theme.colors.neutral.chromatic[100]};
    transition: box-shadow 0.5s;
    width: 100%;
    min-width: 300px;
    max-width: 500px;
  `}

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.sm[4]};
    cursor: pointer;
  }
`;

export { PropertyCardWrapper };
